module.exports = __webpack_public_path__ + "fonts/font.df02c2a.woff2";